var immutable = require('./immutable');

module.exports = {
  immutable: immutable,
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/remotedev-serialize/index.js
 ** module id = 876
 ** module chunks = 0
 **/